/**
 * メニューで使用可能なアイコンの登録リスト
 * 新しいアイコンを追加する場合はここにインポートと登録を行い、ビルドし直す
 */
import { AiFillAlert } from "react-icons/ai";
import { BsFillSignStopFill ,BsFillMenuButtonFill} from "react-icons/bs";
import {
  FaBoxOpen,
  FaCalendarCheck,
  FaCamera,
  FaFileImport,
  FaHistory,
  FaLine,
  FaPrint,
  FaQrcode,
  FaRegFilePdf,
  FaSearch,
  FaStar,
  FaStore,
  FaWarehouse,
  FaWineBottle,
  FaBox,
  FaBuilding,
  FaBell,
  FaSitemap,
  FaChartPie,
  FaWalking,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FaChartBar } from "react-icons/fa6";
import { RiTeamFill } from "react-icons/ri";
import { FcSalesPerformance } from "react-icons/fc";
import { GrVmMaintenance } from "react-icons/gr";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoIosSettings } from "react-icons/io";
import { LuSheet } from "react-icons/lu";
import { MdAssignment } from "react-icons/md";
import { SlNote } from "react-icons/sl";
import { TbCertificate, TbSwitch, TbTruckDelivery } from "react-icons/tb";
import { GiCargoShip } from "react-icons/gi";

export const ICON_REGISTRY = {
  AiFillAlert,
  BsFillSignStopFill,
  BsFillMenuButtonFill,
  FaBoxOpen,
  FaCalendarCheck,
  FaCamera,
  FaFileImport,
  FaHistory,
  FaLine,
  FaPrint,
  FaQrcode,
  FaRegFilePdf,
  FaSearch,
  FaStar,
  FaStore,
  FaBox,
  FaWarehouse,
  FaWineBottle,
  FaBuilding,
  FaSitemap,
  FaChartPie,
  FaChartBar,
  FaWalking,
  FaMapMarkerAlt,
  FcSalesPerformance,
  GrVmMaintenance,
  IoDocumentTextOutline,
  IoIosSettings,
  LuSheet,
  MdAssignment,
  SlNote,
  TbCertificate,
  TbSwitch,
  TbTruckDelivery,
  GiCargoShip,
  RiTeamFill,
  FaBell,
};

/** 登録済みアイコン名の一覧（アイコンピッカー用） */
export const ICON_IDS = Object.keys(ICON_REGISTRY);
